import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-login-layout',
    imports: [RouterOutlet, TranslateModule],
    templateUrl: './login-layout.component.html',
    styleUrl: './login-layout.component.scss'
})
export class LoginLayoutComponent {}
